export type VesselTypeOption = {
  value: string
  label: string
}

export const VESSEL_TYPE_OPTIONS: VesselTypeOption[] = [
  {value: 'OIL_TANKER', label: 'Oil Tanker'},
  {value: 'TANKER', label: 'Tanker'},
  {value: 'CHEMICAL_TANKER', label: 'Chemical Tanker'},
  {value: 'PRODUCT_TANKER', label: 'Product Tanker'},
  {value: 'GAS_CARRIER', label: 'Gas Carrier'},
  {value: 'LNG_CARRIER', label: 'LNG Carrier'},
  {value: 'LPG_CARRIER', label: 'LPG Carrier'},
  {value: 'CRUDE_OIL_TANKER', label: 'Crude Oil Tanker'},
  {value: 'BUNKER_TANKER', label: 'Bunker Tanker'},
  {value: 'CONTAINER_SHIP', label: 'Container Ship'},
  {value: 'BULK_CARRIER', label: 'Bulk Carrier'},
  {value: 'GENERAL_CARGO_SHIP', label: 'General Cargo Ship'},
  {value: 'RORO_CARGO_SHIP', label: 'Ro-Ro Cargo Ship'},
  {value: 'HEAVY_LIFT_VESSEL', label: 'Heavy Lift Vessel'},
  {value: 'REEFER_SHIP', label: 'Reefer Ship'},
  {value: 'MULTI_PURPOSE_VESSEL', label: 'Multi-purpose Vessel'},
  {value: 'CRUISE_SHIP', label: 'Cruise Ship'},
  {value: 'FERRY', label: 'Ferry'},
  {value: 'ROPAX_VESSEL', label: 'Ro-Pax Vessel'},
  {value: 'HIGH_SPEED_CRAFT', label: 'High-Speed Craft'},
  {value: 'OFFSHORE_SUPPLY_VESSEL', label: 'Offshore Supply Vessel'},
  {value: 'AHTS', label: 'Anchor Handling Tug Supply'},
  {value: 'PSV', label: 'Platform Supply Vessel'},
  {value: 'SEISMIC_SURVEY_VESSEL', label: 'Seismic Survey Vessel'},
  {value: 'CABLE_LAYER', label: 'Cable Layer'},
  {value: 'RESEARCH_VESSEL', label: 'Research Vessel'},
  {value: 'DSV', label: 'Diving Support Vessel'},
  {value: 'FIREFIGHTING_VESSEL', label: 'Firefighting Vessel'},
  {value: 'PIPE_LAYING_VESSEL', label: 'Pipe Laying Vessel'},
  {value: 'GRAB_DREDGER', label: 'Grab Dredger'},
  {value: 'TSHD', label: 'TSHD'},
  {value: 'SURVEY_BOAT', label: 'Survey Boat'},
  {value: 'MOORING_BOAT', label: 'Mooring Boat'},
  {value: 'HARBOR_TUG', label: 'Harbor Tug'},
  {value: 'OCEAN_TUG', label: 'Ocean Tug'},
  {value: 'WORK_BOAT', label: 'Work Boat'},
  {value: 'PILOT_BOAT', label: 'Pilot Boat'},
  {value: 'SECURITY_BOAT', label: 'Security Boat'},
  {value: 'PATROL_BOAT', label: 'Patrol Boat'},
  {value: 'CUTTER_SUCTION_DREDGER', label: 'Cutter Suction Dredger'},
  {value: 'BARGE', label: 'Barge'},
  {value: 'SPUD_PONTOON', label: 'Spud Pontoon'},
]

export const matchVesselTypeOption = (rawType?: string | null): string => {
  if (!rawType) return ''
  const trimmed = rawType.trim()
  if (!trimmed) return ''

  // 1. Exact match on value (case-insensitive)
  const exactVal = VESSEL_TYPE_OPTIONS.find(
    (opt) => opt.value.toLowerCase() === trimmed.toLowerCase()
  )
  if (exactVal) return exactVal.value

  // 2. Exact match on label (case-insensitive)
  const exactLabel = VESSEL_TYPE_OPTIONS.find(
    (opt) => opt.label.toLowerCase() === trimmed.toLowerCase()
  )
  if (exactLabel) return exactLabel.value

  // 3. Normalized match (removing spaces, underscores, dashes)
  const normRaw = trimmed.toUpperCase().replace(/[\s_-]+/g, '')
  const normMatch = VESSEL_TYPE_OPTIONS.find((opt) => {
    const normVal = opt.value.replace(/_/g, '')
    const normLab = opt.label.toUpperCase().replace(/[\s_-]+/g, '')
    return (
      normRaw === normVal ||
      normRaw === normLab ||
      normVal.includes(normRaw) ||
      normRaw.includes(normVal) ||
      normLab.includes(normRaw) ||
      normRaw.includes(normLab)
    )
  })

  if (normMatch) return normMatch.value

  return trimmed
}

export const isLoaderDischargeApplicable = (vesselType?: string | null): boolean => {
  if (!vesselType) return false
  const norm = vesselType.toUpperCase().replace(/[\s_-]+/g, ' ')
  return (
    norm.includes('BULK') ||
    norm.includes('GENERAL') ||
    norm.includes('MULTI') ||
    norm.includes('HEAVY') ||
    norm.includes('RORO') ||
    norm.includes('REEFER') ||
    norm.includes('DRY')
  )
}

export const LOAD_DISCHARGE_RATE_UNITS = [
  'm³/hr',
  'MT/hr',
  'MT/day',
  'LT/hr',
  'BBL/hr',
  'TPH',
]


